import React, { FC, useEffect, useRef, useState } from "react";
import { redirectKeyPressToClick } from "../../../../helpers/interactionHandlers";
import { UserIconSvg } from "../../../icons/UserIconSvg";
import {
  StyledDropdownMenu,
  StyledHeaderDropdown,
  StyledHeaderSupport,
  StyledHeaderSupportLink,
  StyledIconAndText,
  StyledLabel,
  StyledUser,
} from "./index.styled";

export interface UserProps {
  accountUrl?: string;
  hideIcon?: boolean;
  isLoggedIn: boolean;
  isMobile?: boolean;
  logInUrl?: string;
  logOutUrl?: string;
  onAccountClicked?: React.MouseEventHandler;
  onLogInClicked?: React.MouseEventHandler;
  onLogOutClicked?: React.MouseEventHandler;
  onSignUpClicked?: React.MouseEventHandler;
  shouldShow?: boolean;
  showATDContact?: boolean;
  signUpUrl?: string;
}

export const User: FC<{ user: UserProps }> = ({ user }) => {
  const {
    accountUrl,
    hideIcon,
    isLoggedIn,
    logInUrl,
    logOutUrl,
    onAccountClicked,
    onLogInClicked,
    onLogOutClicked,
    shouldShow = true,
    showATDContact = false,
  } = user;

  const toggleNode = useRef<HTMLDivElement>(null);
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false);

  const toggleDropdownMenu = () => {
    setIsDropdownMenuOpen(!isDropdownMenuOpen);
  };
  const closeMenu = () => setIsDropdownMenuOpen(false);
  const closeDropdownMenu = (event: MouseEvent) => {
    if (
      toggleNode &&
      toggleNode.current &&
      toggleNode.current.contains(event.target as Node)
    ) {
      // the user clicked inside the dropdown; do nothing
      return;
    }
    setIsDropdownMenuOpen(false);
  };

  useEffect(() => {
    if (isDropdownMenuOpen) {
      document.addEventListener("mousedown", closeDropdownMenu);
    } else {
      document.removeEventListener("mousedown", closeDropdownMenu);
    }

    return (): void => {
      document.removeEventListener("mousedown", closeDropdownMenu);
    };
  }, [isDropdownMenuOpen]);

  if (!shouldShow) {
    return null;
  }

  if (isLoggedIn)
    return (
      <StyledUser ref={toggleNode}>
        <StyledIconAndText
          tabIndex={0}
          onKeyDown={redirectKeyPressToClick}
          onClick={toggleDropdownMenu}
        >
          {!hideIcon && <UserIconSvg />}
          <StyledLabel>Account</StyledLabel>
        </StyledIconAndText>

        <StyledDropdownMenu isOpen={isDropdownMenuOpen}>
          {showATDContact && (
            <StyledHeaderSupport>
              <div>Support:</div>
              <StyledHeaderSupportLink>
                ATDorders@pepsico.com
              </StyledHeaderSupportLink>
            </StyledHeaderSupport>
          )}

          {accountUrl ? (
            <StyledHeaderDropdown href={accountUrl} tabIndex={0}>
              Account
            </StyledHeaderDropdown>
          ) : onAccountClicked ? (
            <StyledHeaderDropdown
              onClick={(event) => {
                closeMenu();
                onAccountClicked && onAccountClicked(event);
              }}
              onKeyDown={redirectKeyPressToClick}
              tabIndex={0}
            >
              Account
            </StyledHeaderDropdown>
          ) : null}

          {logOutUrl ? (
            <a href={logOutUrl} tabIndex={0}>
              Log Out
            </a>
          ) : onLogOutClicked ? (
            <div
              onClick={(event) => {
                closeMenu();
                onLogOutClicked && onLogOutClicked(event);
              }}
              onKeyDown={redirectKeyPressToClick}
              tabIndex={0}
            >
              Log Out
            </div>
          ) : null}
        </StyledDropdownMenu>
      </StyledUser>
    );

  return (
    <StyledUser>
      {logInUrl && (
        <a href={logInUrl} tabIndex={0}>
          <StyledIconAndText>
            {!hideIcon && <UserIconSvg />}
            <StyledLabel>Account</StyledLabel>
          </StyledIconAndText>
        </a>
      )}

      {!logInUrl && onLogInClicked && (
        <div
          onClick={onLogInClicked}
          onKeyDown={redirectKeyPressToClick}
          tabIndex={0}
        >
          <StyledIconAndText>
            {!hideIcon && <UserIconSvg />}
            <StyledLabel>Login</StyledLabel>
          </StyledIconAndText>
        </div>
      )}
    </StyledUser>
  );
};
